export default "__VITE_ASSET__d56be95d__"